module.exports = __webpack_public_path__ + "static/media/advenio-grey.de903709.svg";